/* eslint-disable no-template-curly-in-string */
/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import * as yup from 'yup';

import Formatter from './Formatter';

yup.setLocale({
    mixed: {
        oneOf: ({ values }: any) => `Povoleny jsou pouze tyto hodnoty: ${values}`,
        notType: ({ type, originalValue }: any) => {//value, path,
            if (!originalValue) return 'Pole je povinné';

            if (type === 'date') return 'Pole musí být ve formátu dd.mm.rrrr';
            if (type === 'number') return 'Pole musí být číslo';
            return 'Nepodporovaný formát';
        },
        required: 'Pole je povinné'
    },
    string: {
        email: 'Chybně zadaný e-mail',
        min: 'Nedostatečná délka (minimálně ${min} znaků)',
        max: 'Překročena maximální délka (maximálně ${max} znaků)'
    },
    number: {
        min: 'Povolené minimum je ${min}',
        max: 'Povolené maximum je ${max}',
        integer: 'Musí být celé číslo'
    },
    date: {
        min: ({ min }: any) => `Datum nesmí být před ${Formatter.dateToString(min)}`,
        max: ({ max }: any) => `Datum nesmí být po ${Formatter.dateToString(max)}`
    }
});

export const testFileSize = (maxSize: number) => (files: File[] | null | undefined): boolean => {
    if (files?.length) {
        return files
            .map(file => file.size)
            .every(size => size <= maxSize);
    }
    return true;
};

export const testFileType = (types: string[]) => (files: File[] | null | undefined): boolean => {
    // eslint-disable-next-line no-useless-escape
    const tests = types.map(type => new RegExp(`\.${type}$`));

    if (files?.length) {
        return files
            .map(file => file.name.toLowerCase())
            .every(name => tests.some(regexp => regexp.test(name)));
    }
    return true;
};

export default yup;
